import { createBreadcrumb } from '../util/createBreadcrumb.js';
var _LAST_BREADCRUMB = null;

function handleScope(scope) {
  var newBreadcrumb = scope.getLastBreadcrumb(); // Listener can be called when breadcrumbs have not changed, so we store the
  // reference to the last crumb and only return a crumb if it has changed

  if (_LAST_BREADCRUMB === newBreadcrumb || !newBreadcrumb) {
    return null;
  }

  _LAST_BREADCRUMB = newBreadcrumb;

  if (newBreadcrumb.category && (['fetch', 'xhr', 'sentry.event', 'sentry.transaction'].includes(newBreadcrumb.category) || newBreadcrumb.category.startsWith('ui.'))) {
    return null;
  }

  return createBreadcrumb(newBreadcrumb);
}

export { handleScope };